import { useGate } from "@nestoca/gate-react";
import { Card, Flex, Skeleton, Typography } from "@nestoca/ui";
import { useSupportContact } from "@shared/ui";
import { useRouter } from "next/router";

import styles from "./burger-menu.module.scss";

export const BurgerMenuContact = () => {
  const { query } = useRouter();
  const gate = useGate();
  const isExternalBroker = gate.getRole() === "externalbroker";
  const applicationId = Number(query?.applicationId);

  if (isExternalBroker || !applicationId) {
    return null;
  }

  return <BurgerMenuContactCard applicationId={applicationId} />;
};

const BurgerMenuContactCard = ({
  applicationId,
}: {
  applicationId: number;
}) => {
  const { supportContactInfo, contactLabel, isLoading } = useSupportContact({
    applicationId,
  });

  return (
    <Card
      shadow="medium"
      className={styles["burger-menu__contact"]}
      data-testid="burger-menu-contact"
    >
      {isLoading ? (
        <Flex direction="column" gap={4}>
          <Skeleton animate width={120} />
          <Skeleton animate width={180} />
        </Flex>
      ) : (
        <Flex direction="column" gap={5}>
          <Typography as="h2" font="semantic-component-small-semibold">
            {contactLabel}
          </Typography>
          {supportContactInfo.map((info) =>
            info.link ? (
              <Typography
                key={info.id}
                as="a"
                href={info.link}
                font="semantic-component-medium-medium"
                textColor="var(--color-status-info-foreground)"
                data-dd-action-name="contact link"
              >
                {info.data}
              </Typography>
            ) : (
              <Typography key={info.id} font="semantic-component-medium-medium">
                {info.data}
              </Typography>
            )
          )}
        </Flex>
      )}
    </Card>
  );
};
